import { FocusAreaViewOptional } from "@/domain/focus-area/components/focus-area-view-optional";
import { DatatableRowData, isRawRow, SectionData } from "@/domain/view/components/datatable/datatable-types";
import { useDatatableContext } from "@/domain/view/components/datatable/use-datatable-context";
import { Row } from "@tanstack/react-table";

import { useGetFocusArea } from "../../hooks/api/use-get-focus-area";

export interface DatatableFocusAreaSectionHeaderProps<TData extends DatatableRowData> {
  data: SectionData<TData>;
  currentRow: Row<SectionData<TData>>;
}

export const DatatableFocusAreaSectionHeader = <TData extends DatatableRowData>({
  data,
}: DatatableFocusAreaSectionHeaderProps<TData>) => {
  const { focusArea } = useGetFocusArea({ id: data.key });

  const { table } = useDatatableContext<TData>();

  const rowModel = table.getFilteredRowModel();
  const filteredRows = rowModel.flatRows.filter((row) => {
    if (!isRawRow(row.original)) {
      return false;
    }
    return data.key === data.getSectionKey(row.original);
  });
  const count = filteredRows.length;

  return (
    <div className="flex h-full flex-row items-center justify-between gap-2 bg-foreground/3 px-5">
      <div className="flex flex-row items-center justify-start gap-2">
        <FocusAreaViewOptional focusArea={focusArea} logoOnly={false} className="h-3.5 w-3.5" />
        <span className="text-xs text-muted-foreground">{count}</span>
      </div>
      <div className="flex flex-row items-center justify-end"></div>
    </div>
  );
};
